import React from "react";
import { useLocation } from "react-router-dom";
import Moment from "react-moment";

const UserViewForm = () => {
    const location = useLocation();
    const { data } = location.state || {};


    return (
        <div className="container-fluid p-0" style={{ overflow: "hidden" }}>
            <div className="row g-0" style={{ minHeight: "75vh", overflow: "hidden" }}>
                {/* Left Panel */}
                <div className="col-md-12 p-4 bg-white">
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(3, 1fr)',
                        gap: '3rem 5rem'
                    }}>
                        <div className="field">
                            <span className="label">Task Name</span>
                            <span className="value">{data?.name || 'NA'}</span>
                        </div>
                        <div className="field">
                            <span className="label">Task Type</span>
                            <span className="value">{data?.task_type === 0 ? "Activity" : "Notification" || 'NA'}</span>
                        </div>
                        <div className="field">
                            <span className="label">Assign Type</span>
                            <span className="value">{data?.assign_type === 0 ? "Group" : "Users" || 'NA'}</span>
                        </div>
                        <div className="field">
                            <span className="label">Assign Task</span>
                            <span className="value">{data?.assign_task === 0 ? "Anyone" : "Everyone" || "NA"}</span>
                        </div>
                        <div className="field">
                            <span className="label">Created On</span>
                            <span className="value">
                                <Moment format="DD-MM-YYYY, hh:mm A">{data?.createdOn || 'NA'}</Moment>
                            </span>
                        </div>
                    </div>

                    {/* Displaying userTaskMapList */}
                    <div style={{ marginTop: '3rem' }}>
                        <h4 style={{ fontFamily: 'Poppins', fontSize: '14px', textDecoration: 'underline', color: '#FFA100' }}>User Task Lists</h4>
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(3, 1fr)',
                            gap: '1rem'
                        }}>
                            {data?.userTaskMapList && data.userTaskMapList.length > 0 ? (
                                data.userTaskMapList.map((task, index) => (
                                    <div key={index} className="field">
                                       
                                        <div className="field" >
                                            <span className="label">{index + 1}. Assigned To</span>
                                            <span className="value" style={{ marginBottom: '8px' }}>{task.assigned_to || 'NA'}</span>
                                        </div>
                                        <div className="field">
                                            <span className="label">Status</span>
                                            <span className="value" style={{ marginBottom: '8px' }}>{task.status || 'NA'}</span>
                                        </div>
                                        <div className="field">
                                            <span className="label">Updated On</span>
                                            <span className="value" style={{ marginBottom: '8px' }}>
                                                <Moment format="DD-MM-YYYY, hh:mm A">{task.created_on || 'NA'}</Moment>
                                            </span>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <span>No task data available</span>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UserViewForm;
